/**
 * Кнопка «Помощник покупок» по центру нижней строки витрины (Игорь 01.10: «не в середине белой плашки,
 * в которой „В корзину“ — чуть-чуть ниже нужно опустить»).
 *
 * Лаунчер виджета стоит фиксированно (bottom: var(--cdp-launcher-bottom, 20px)). Витрина знает свои нижние
 * строки — липкую плашку товара/корзины (data-sticky-cta) и нижнее меню на узком экране — и ставит переменную
 * так, чтобы центр кнопки совпал с центром главной кнопки строки. Нет строки — оставляем 20 px виджета.
 */
export const LAUNCHER_SIZE = 56;
const DEFAULT_BOTTOM = 20;

export interface Rect { top: number; bottom: number; height: number }

/** Расстояние от низа окна до низа кнопки, при котором её центр совпадает с центром `target`. Чистая функция. */
export function launcherBottomFor(target: Rect | null, viewportHeight: number, nav: Rect | null): number {
  if (target && target.height > 0) {
    const center = (target.top + target.bottom) / 2;
    return Math.max(0, Math.round(viewportHeight - center - LAUNCHER_SIZE / 2));
  }
  // Нет плашки — над нижним меню (если оно есть), иначе как у виджета.
  if (nav && nav.height > 0) return Math.round(viewportHeight - nav.top + 12);
  return DEFAULT_BOTTOM;
}

function visibleRect(selector: string): Rect | null {
  const el = document.querySelector<HTMLElement>(selector);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  return r.height > 0 && r.width > 0 ? { top: r.top, bottom: r.bottom, height: r.height } : null;
}

/** Следит за раскладкой и держит лаунчер по центру нижней строки. Возвращает функцию остановки. */
export function alignLauncher(host: HTMLElement): () => void {
  let frame = 0;
  const apply = (): void => {
    frame = 0;
    const cta = visibleRect("[data-sticky-cta] button, [data-sticky-cta] [data-sticky-cta-main]");
    const nav = visibleRect("[data-bottom-nav]");
    host.style.setProperty("--cdp-launcher-bottom", `${launcherBottomFor(cta, window.innerHeight, nav)}px`);
  };
  const schedule = (): void => { if (!frame) frame = requestAnimationFrame(apply); };
  apply();
  window.addEventListener("resize", schedule);
  // Плашка появляется/исчезает при переходах по SPA и изменении корзины — следим за DOM.
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["class", "style"] });
  return () => { window.removeEventListener("resize", schedule); observer.disconnect(); if (frame) cancelAnimationFrame(frame); };
}
